module.exports = __webpack_public_path__ + "img/aggregated.33b90907.svg";